import React, {Component} from 'react';
import {groupByMonth, months} from "../util/timeseries";
import Plotly from 'plotly.js-basic-dist';
// customizable method: use your own `Plotly` object
import createPlotlyComponent from 'react-plotly.js/factory';
import {isEqual} from "../util/equality";
const Plot = createPlotlyComponent(Plotly);


export default class MonthlyChart extends Component {
    style = {
        width: "100%",
        height: "100%"
    };

    shouldComponentUpdate (nextProps, nextState) {
        // only re-render if the props (i.e. data) has changed
        // we need this since the render method can be a bit heavy/slow
        return !isEqual(nextProps, this.props);
    }

    render() {
        const series = this.props.series;
        let data = [];
        if (series) {
            let res = groupByMonth(series);
            const monthlyValues = res.monthlyValues;
            const averages = res.averages;

            // add the line first
            let averageLine = {
                x: months,
                y: averages,
                name: 'mean',
                type: 'scatter',
                mode: 'lines'
            };
            data.push(averageLine);

            let startYear = 1998;
            for (let i = 0; i < monthlyValues.length; i++) {
                let val = {
                    x: months,
                    y: monthlyValues[i],
                    name: startYear + i,
                    type: 'scatter',
                    mode: 'markers'
                };
                data.push(val);
            }


        }
        const layout = {
            title: this.props.title,
            autosize: true,
            margin: {
                l:30,
                r:0,
                t:80,
                b:30
            }
        };

        return(
            <div>
                <Plot
                    data={data}
                    layout={layout}
                    config={{displaylogo: false, modeBarButtonsToRemove:['sendDataToCloud'], responsive:true}}
                    useResizeHandler={true}
                    style={this.style}/>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/MonthlyChart.jsx